module.exports = __webpack_public_path__ + "img/Desktop-screenshot-p-800.80732a76.png";